import React, { useState } from "react";
import { useDispatch } from 'react-redux'
import "./ReportDetails.scss";
import {
  MotifIcon,
  MotifButton,
  MorifButtonGroup,
  MotifDropdownPortal,
  MotifDropdownItem,
  MotifAccordion,
  MotifAccordionTrigger,
  MotifAccordionContent,
  MotifProgressLoader,
  MotifFormField,
  MotifLabel,
  MotifSelect,
  MotifOption,
} from "@ey-xd/motif-react";
import { MotifButtonGroup } from '@ey-xd/motif-react/Button';
import Input from "common/components/Input/Input";
import { calculateRiskScore } from '../../../redux/actions/RiskScore/riskScore'
import { MAX_INPUT_LENGTH } from "components/Clients/constants";

const ReportDetails = ({
  reportDetails,
  riskScore = {},
  generateRiskScore = {},
  reportName,
  clientName,
  setShowSpinner
}: any) => {

  const dispatch = useDispatch()

  const [threatLevelAttributes, setThreatLevelAttributes] = useState(generateRiskScore['Threat Level Attributes'] || {})
  const [likelihooLevelAttributes, setLikelihoodLevelAttributes] = useState(generateRiskScore['Likelihood Level Attributes'] || {})
  console.log('get risk score', generateRiskScore)

  const getDate = (date: any) => {
    return new Date(date).toLocaleDateString();
  };
  const getTime = (date: any) => {
    return new Date(date).toLocaleTimeString();
  };

  const onChangethreatLevelAttributes = (key: string, value: string) => {
    const newObj = { ...threatLevelAttributes, [key]: value };
    setThreatLevelAttributes(newObj)
  }

  const onChangeLikelihoodLevelAttributes = (key: string, value: string) => {
    const newObj = { ...likelihooLevelAttributes, [key]: value };
    setLikelihoodLevelAttributes(newObj)
  }

  const handleSubmit = () => {
    const newObject = { ...generateRiskScore, ['Threat Level Attributes']: threatLevelAttributes, ['Likelihood Level Attributes']: likelihooLevelAttributes }
    setShowSpinner(true)
    dispatch(calculateRiskScore(newObject)).then(() => setShowSpinner(false))

  }
  return (
    <div className="reportDetailsWrapper">
      <div className="reportDetails">
        <div className="reportDetails__item">
          <div className="reportDetails__item__title">Report Name</div>
          <div className="reportDetails__item__text">
            {reportName || reportDetails.reportName}
          </div>
        </div>
        <div className="reportDetails__item">
          <div className="reportDetails__item__title">Client Name</div>
          <div className="reportDetails__item__text">
            {clientName}
          </div>
        </div>
        <div className="reportDetails__item">
          <div className="reportDetails__item__title">Date</div>
          <div className="reportDetails__item__text">
            {getDate(new Date())}
          </div>
        </div>
        <div className="reportDetails__item">
          <div className="reportDetails__item__title">Time</div>
          <div className="reportDetails__item__text">
            {getTime(new Date())}
          </div>
        </div>
      </div>
      <div className="generalInformationHeader">General Information</div>
      <div className="generalInformation">
        <Input label={'Impacted Industries'} value={'healthcare government finance'} maxLength={MAX_INPUT_LENGTH}></Input>
        <Input label={'Activity Group'} value={'Dark Angels'} maxLength={MAX_INPUT_LENGTH} ></Input>
        <Input label={'Region'} value={'US, Japan, Ease Asia'} maxLength={MAX_INPUT_LENGTH} ></Input>
        <Input label={'Motive'} value={'Financial Gain, Data Exfilteration'} maxLength={MAX_INPUT_LENGTH} ></Input>
      </div>
      <div className="riskLevelHeader">Risk Level</div>
      <div className="riskLevel">
        <div>
          <div className="label">Risk Level</div>
          <MotifButtonGroup>
            <MotifButton style={riskScore['Risk Level'] ==='Low' ? { background: '#DBFCE6' }: {}}>Low</MotifButton>
            <MotifButton style={riskScore['Risk Level'] ==='Medium' ? { background: '#FFFACA' }: {}}>Medium</MotifButton>
            <MotifButton style={riskScore['Risk Level'] ==='High' ? { background: '#FFE3C2' }: {}}>High</MotifButton>
            <MotifButton style={riskScore['Risk Level'] ==='Critical' ? { background: '#FFCCCC' }: {}}>Critical</MotifButton>
          </MotifButtonGroup>
        </div>
        <div>
          <div className="label">Risk Score</div>
          <div>{riskScore['Risk Score']}</div>
        </div>
      </div>
      <div className="threatLevelAttributesHeader">Threat Level Attributes</div>
      <div className="threatLevelAttributes">
        <MotifFormField style={{ width: '300px'}}>
          <MotifLabel>Threat</MotifLabel>
          <MotifSelect
            onChange={(val: any) => onChangethreatLevelAttributes('Threat', val)}
            value={threatLevelAttributes['Threat']}
          >
            <MotifOption value="Actor">Actor</MotifOption>
            <MotifOption value="Malware">Malware</MotifOption>
            <MotifOption value="Group">Group</MotifOption>
          </MotifSelect>
        </MotifFormField>
        <MotifFormField style={{ width: '300px'}}>
          <MotifLabel>Association</MotifLabel>
          <MotifSelect
            onChange={(val: any) => onChangethreatLevelAttributes('Associated', val)}
            value={threatLevelAttributes['Associated']}
            visibleOptions={3}
          >
            <MotifOption value="Yes">Yes</MotifOption>
            <MotifOption value="No">No</MotifOption>
          </MotifSelect>
        </MotifFormField>
        <MotifFormField style={{ width: '300px'}}>
          <MotifLabel>Capability</MotifLabel>
          <MotifSelect
            onChange={(val: any) => onChangethreatLevelAttributes('Capability', val)}
            value={threatLevelAttributes['Capability']}
            visibleOptions={3}
          >
            <MotifOption value="Nation state">Nation state</MotifOption>
            <MotifOption value="Cybercriminals">Cybercriminals</MotifOption>
            <MotifOption value="Hactivists">Hactivists</MotifOption>
            <MotifOption value="Terrorist groups">Terrorist groups</MotifOption>
            <MotifOption value="Thrill seekers">Thrill seekers</MotifOption>
            <MotifOption value="Script kiddie">Script kiddie</MotifOption>
          </MotifSelect>
        </MotifFormField>
        <MotifFormField style={{ width: '300px'}}>
          <MotifLabel>Activity Level</MotifLabel>
          <MotifSelect
            onChange={(val: any) => onChangethreatLevelAttributes('Activity Level', val)}
            value={threatLevelAttributes['Activity Level']}
            visibleOptions={3}
          >
            <MotifOption value='Highly Active'>Highly Active</MotifOption>
            <MotifOption value='Active'>Active</MotifOption>
            <MotifOption value='Medium'>Medium</MotifOption>
            <MotifOption value='Low'>Low</MotifOption>
          </MotifSelect>
        </MotifFormField>
        <MotifFormField style={{ width: '300px'}}>
          <MotifLabel>Active Since</MotifLabel>
          <MotifSelect
            onChange={(val: any) => onChangethreatLevelAttributes('Activity Since', val)}
            value={threatLevelAttributes['Activity Since']}
            visibleOptions={3}
          >
            <MotifOption value={'>=5 years'}>{'Greater or equal to 5 years'}</MotifOption>
            <MotifOption value={'2-4 years'}>{'2 to 4 years'}</MotifOption>
            <MotifOption value={'<1 year'}>{'less than 1 year'}</MotifOption>
          </MotifSelect>
        </MotifFormField>
        <MotifFormField style={{ width: '300px'}}>
          <MotifLabel>APT</MotifLabel>
          <MotifSelect
            onChange={(val: any) => onChangethreatLevelAttributes('APT', val)}
            value={threatLevelAttributes['APT']}
            visibleOptions={3}
          >
            <MotifOption value="Yes">Yes</MotifOption>
            <MotifOption value="No">No</MotifOption>
          </MotifSelect>
        </MotifFormField>
        <MotifFormField style={{ width: '300px'}}>
          <MotifLabel>Zero day exploits</MotifLabel>
          <MotifSelect
            onChange={(val: any) => onChangethreatLevelAttributes('0 Days Exploit', val)}
            value={threatLevelAttributes['0 Days Exploit']}
            visibleOptions={3}
          >
            <MotifOption value="Yes">Yes</MotifOption>
            <MotifOption value="No">No</MotifOption>
          </MotifSelect>
        </MotifFormField>
        <MotifFormField style={{ width: '300px'}}>
          <MotifLabel>Attack Type</MotifLabel>
          <MotifSelect
            onChange={(val: any) => onChangethreatLevelAttributes('Attack Type', val)}
            value={threatLevelAttributes['Attack Type']}
            visibleOptions={3}
          >
            <MotifOption value="Ransomware attacks">Ransomware attacks</MotifOption>
            <MotifOption value="Internet-faced device attacks">Internet-faced device attacks</MotifOption>
            <MotifOption value="Lock-and-leak attacks">Lock-and-leak attacks</MotifOption>
            <MotifOption value="Denial of Service">Denial of Service</MotifOption>
            <MotifOption value="Data Leaks">Data Leaks</MotifOption>
            <MotifOption value="Cryptomining">Cryptomining</MotifOption>
            <MotifOption value="Hactivism">Hactivism</MotifOption>
          </MotifSelect>
        </MotifFormField>
        <MotifFormField style={{ width: '300px'}}>
          <MotifLabel>Intent</MotifLabel>
          <MotifSelect
            onChange={(val: any) => onChangethreatLevelAttributes('Intent', val)}
            value={threatLevelAttributes['Intent']}
            visibleOptions={3}
          >
            <MotifOption value="Brand Damage">Brand Damage</MotifOption>
            <MotifOption value="Financial Gain">Financial Gain</MotifOption>
            <MotifOption value="Distruption">Distruption</MotifOption>
            <MotifOption value="Recognition & Achievement">Recognition & Achievement</MotifOption>
            <MotifOption value="Espionage">Espionage</MotifOption>
            <MotifOption value="Political">Political</MotifOption>
          </MotifSelect>
        </MotifFormField>
      </div>

      <div className="likelihoodAttributesHeader">Likelihood Attributes</div>
      <div className="likelihoodAttributes">
        <MotifFormField style={{ width: '300px'}}>
          <MotifLabel>Recent Intent Laws</MotifLabel>
          <MotifSelect
            onChange={(val: any) => onChangeLikelihoodLevelAttributes('Recent Intel News', val)}
            value={likelihooLevelAttributes['Recent Intel News']}
            visibleOptions={3}
          >
            <MotifOption value="Yes">Yes</MotifOption>
            <MotifOption value="No">No</MotifOption>
          </MotifSelect>
        </MotifFormField>
        <MotifFormField style={{ width: '300px'}}>
          <MotifLabel>Sectors Affected</MotifLabel>
          <MotifSelect
            onChange={(val: any) => onChangeLikelihoodLevelAttributes('Sectors Affected', val)}
            value={likelihooLevelAttributes['Sectors Affected']}
            visibleOptions={3}
          >
            <MotifOption value="Yes">Yes</MotifOption>
            <MotifOption value="No">No</MotifOption>
            <MotifOption value="May be">May be</MotifOption>
          </MotifSelect>
        </MotifFormField>
        <MotifFormField style={{ width: '300px'}}>
          <MotifLabel>Country Affected</MotifLabel>
          <MotifSelect
            onChange={(val: any) => onChangeLikelihoodLevelAttributes('Country Affected', val)}
            value={likelihooLevelAttributes['Country Affected']}
            visibleOptions={3}
          >
            <MotifOption value="Yes">Yes</MotifOption>
            <MotifOption value="No">No</MotifOption>
            <MotifOption value="May be">May be</MotifOption>
          </MotifSelect>
        </MotifFormField>
        <MotifFormField style={{ width: '300px'}}>
          <MotifLabel>Geography Affected</MotifLabel>
          <MotifSelect
            onChange={(val: any) => onChangeLikelihoodLevelAttributes('Geography Affected', val)}
            value={likelihooLevelAttributes['Geography Affected']}
            visibleOptions={3}
          >
            <MotifOption value="Yes">Yes</MotifOption>
            <MotifOption value="No">No</MotifOption>
            <MotifOption value="May be">May be</MotifOption>
          </MotifSelect>
        </MotifFormField>
        <MotifFormField style={{ width: '300px'}}>
          <MotifLabel>Technology Stack Affected</MotifLabel>
          <MotifSelect
            onChange={(val: any) => onChangeLikelihoodLevelAttributes('Technology Stack', val)}
            value={likelihooLevelAttributes['Technology Stack']}
            visibleOptions={3}
          >
            <MotifOption value="Yes">Yes</MotifOption>
            <MotifOption value="No">No</MotifOption>
            <MotifOption value="May be">May be</MotifOption>
          </MotifSelect>
        </MotifFormField>
        <MotifFormField style={{ width: '300px'}}>
          <MotifLabel>News Timeframe</MotifLabel>
          <MotifSelect
            onChange={(val: any) => onChangeLikelihoodLevelAttributes('News Timeframe', val)}
            value={likelihooLevelAttributes['News Timeframe']}
            visibleOptions={3}
          >
            <MotifOption value="1-2 days">1-2 days</MotifOption>
            <MotifOption value="3-7 days">3-7 days</MotifOption>
            <MotifOption value="> 7 days">{'> 7 days'}</MotifOption>
          </MotifSelect>
        </MotifFormField>
        <MotifFormField style={{ width: '300px'}}>
          <MotifLabel>Multiple Intels</MotifLabel>
          <MotifSelect
            onChange={(val: any) => onChangeLikelihoodLevelAttributes('Multiple Intels', val)}
            value={likelihooLevelAttributes['Multiple Intels']}
            visibleOptions={3}
          >
            <MotifOption value="Yes">Yes</MotifOption>
            <MotifOption value="No">No</MotifOption>
          </MotifSelect>
        </MotifFormField>
        <MotifFormField style={{ width: '300px'}}>
          <MotifLabel>Intel Source Reliability</MotifLabel>
          <MotifSelect
            onChange={(val: any) => onChangeLikelihoodLevelAttributes('Reliable Source', val)}
            value={likelihooLevelAttributes['Reliable Source']}
            visibleOptions={3}
          >
            <MotifOption value="Yes">Yes</MotifOption>
            <MotifOption value="No">No</MotifOption>
            <MotifOption value="Neutral">Neutral</MotifOption>
          </MotifSelect>
        </MotifFormField>
        <MotifFormField style={{ width: '300px'}}>
          <MotifLabel>Intel Source Accuracy</MotifLabel>
          <MotifSelect
            onChange={(val: any) => onChangeLikelihoodLevelAttributes('Intel accuracy', val)}
            value={likelihooLevelAttributes['Intel accuracy']}
            visibleOptions={3}
          >
            <MotifOption value="Yes">Yes</MotifOption>
            <MotifOption value="No">No</MotifOption>
            <MotifOption value="Neutral">Neutral</MotifOption>
          </MotifSelect>
        </MotifFormField>
      </div>

      <div style={{ padding: 16, display: 'flex', justifyContent: 'end' }}>
        <MotifButton
          size="medium"
          variant="secondary"
          type="button"
          className="button-wrap__cancel"
          onClick={handleSubmit}
        >
          Recalculate Risk Level
        </MotifButton>
      </div>
    </div>
  );
};

export default ReportDetails;
